import { createBrowserRouter, type RouteObject } from "react-router-dom";
import { DocsetLoader } from "./routes/DocsetLoader";
import { DocsetRoute } from "./routes/DocsetRoute";
import { ErrorPage } from "./routes/ErrorPage";
import { APP_BASE_PATH } from "./utils/basePath";

/**
 * Routes for one SPA build. `basePath` is the Vite `base` without its trailing slash
 * (`""` when the SPA is served from the site root), so a docset page is always
 * `${basePath}/:docsetId/<page path>`.
 */
export function createDocsetRoutes(basePath: string): RouteObject[] {
  return [
    {
      path: basePath,
      element: <DocsetLoader />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: ":docsetId/*",
          element: <DocsetRoute />
        }
      ]
    },
    {
      path: "*",
      element: <ErrorPage status={404} />
    }
  ];
}

export const router = createBrowserRouter(createDocsetRoutes(APP_BASE_PATH));
